<template>
  <div class="dialog-search-box">
    <div 
      ref="searchRef"
      class="search-wrapper"
      :style="searchStyle"
    >
      <div class="search-left">
        <slot></slot>
      </div>
      <div class="search-right">
        <el-button 
          v-if="showExpandBtn"
          type="text" 
          size="small" 
          @click="toggleExpand"
        >
          {{ showMore ? '收起' : '展开' }}
          <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
const SINGLE_HEIGHT = 34;

export default {
  name: 'DialogSearchBox',
  props: {
    // 是否默认展开
    defaultExpand: {
      type: Boolean,
      default: false
    },
    // 是否强制显示展开按钮（不依赖内容高度判断）
    forceShowExpand: {
      type: Boolean,
      default: false
    },
    // 折叠时的高度
    collapseHeight: {
      type: Number,
      default: 34
    }
  },
  data() {
    return {
      // 展开收起标志
      showMore: false,
      // 内容实际高度
      contentHeight: SINGLE_HEIGHT,
      // 是否需要显示展开按钮
      needExpand: false
    };
  },
  computed: {
    showExpandBtn() {
      return this.forceShowExpand || this.needExpand;
    },
    searchStyle() {
      return {
        height: this.showMore 
          ? `${this.contentHeight}px` 
          : `${this.collapseHeight}px`
      };
    }
  },
  methods: {
    toggleExpand() {
      this.showMore = !this.showMore;
      this.$emit('expand-change', this.showMore);
    },
    // 计算内容高度并判断是否需要展开按钮
    calcContentHeight() {
      this.$nextTick(() => {
        if (this.$refs.searchRef) {
          this.contentHeight = this.$refs.searchRef.scrollHeight - 15;
          // 如果内容高度超过折叠高度，则需要显示展开按钮
          this.needExpand = this.contentHeight > this.collapseHeight;
        }
      });
    },
    // 手动刷新高度（供外部调用）
    refresh() {
      this.calcContentHeight();
    }
  },
  mounted() {
    this.calcContentHeight();
    
    if (this.defaultExpand) {
      this.showMore = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
.dialog-search-box
  box-sizing border-box
  position relative
  min-height 36px
  color #606266
  background-color #ffffff
  border-radius 5px

.search-wrapper
  display flex
  justify-content space-between
  align-items flex-start
  padding 5px 8px
  background-color #ffffff
  border-radius 6px
  overflow hidden
  transition height ease-in 0.3s

.search-left
  flex 1

.search-right
  padding-top 2px
  white-space nowrap

>>> .el-form-item
  margin-bottom 10px
  margin-right 10px

>>> .el-form-item__label
  padding-right 5px
</style>
